module.exports = __webpack_public_path__ + "static/media/gonerdify.net_Book_delivery.bc1e7938.png";